import ProductDescription from './ProductDescription'

const BSWheatTortillaProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '008BS',
  IsBroadband: true,
  Size: '',
}

export default BSWheatTortillaProduct
